// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.sidebar-checkbox[data-v-12289ade] {\n    line-height: unset;\n    margin: auto;\n}\n.additional-auto-button[data-v-12289ade] {\n    width: 22px;\n    height: 22px;\n}\n", ""]);
// Exports
module.exports = exports;
